import React from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import Translate from 'translate';
import { Form } from "react-form";
import moment from "moment";

import AsyncTable from 'components/HTMLElements/Table/AsyncTable/';
import DeleteModal from 'components/HTMLElements/DeleteModal';
import ChangePassword from '../ChangePassword/';
import {toggleAlertError, toggleLoading} from 'stores/actions/';
import UserService from 'services/UserService';
import { email, equalTo, required } from "../../../../../../constants/InputErrors";
import { FormGroup, Text } from 'components/FormElements';
import SearchParams from 'util/SearchParams';

class UsersList extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: [],
      deleteModalOpened: false,
      ChangePasswordModalOpened: false,
    };
    this.selectedUser = 0;
    this.search = {};
    this.getData = this.getData.bind( this );
    this.toggleChangePassword = this.toggleChangePassword.bind( this );
    //this.changePasswordTo = this.changePasswordTo.bind(this);
  }

  getData( params ) {
    const { isLoading, toggleLoading } = this.props;
    this.params = _.cloneDeep( params );

    if( !isLoading ) toggleLoading( true );

    const apiParams = {
      limit: params.pageSize,
      offset: (params.page * params.pageSize),
    };
    if( params.sorted.length ) apiParams[`sortby[${params.sorted[0].id}]`] = params.sorted[0].desc ? 'DESC' : 'ASC';

   const formattedParams = SearchParams.getSearchParams( this.search, apiParams );
    UserService.getUsers( formattedParams ).then( ( response ) => {
      toggleLoading( false );

      if( response.data ) {
        this.setState( {
          data: response.data.data,
          pages: Math.ceil( response.data.total / params.pageSize ),
          total: response.data.total,
        } );
      }
    } )
  }

  toggleChangePassword = () => {
    const {ChangePasswordModalOpened} = this.state;
    this.setState({ChangePasswordModalOpened: !ChangePasswordModalOpened})
  }

  changePasswordTo = ( userId ) => {
    this.selectedUser = userId;
    this.toggleChangePassword();
  }

  submitForm = ( data ) => {
    this.search = data;
    this.getData( this.params );
  };

  render() {
    const {ChangePasswordModalOpened} = this.state;
    return (
      <div className="box box-default">
        <div className="box-header d-flex justify-content-between">
          <span><Translate id="users"/></span>
          <Link to="/configurations/users/new">
            <button className="btn btn-info"><Translate id="addUser"/></button>
          </Link>
        </div>

        <Form onSubmit={this.submitForm}>
          {( { submitForm, ...rest } ) =>
            <form onSubmit={submitForm} className="d-flex">
              <FormGroup containerClass="col-md-6" className="m-0">
                <Text field="criteria" className="form-control" placeholder="searchByName"/>
              </FormGroup>

              <div className="col-md-6 pl-0">
                <button type="submit" className="btn btn-info mr-2 px-3">
                  <i className="fa fa-filter"/>
                </button>
                <button className="btn btn-danger mr-2 px-3" type="button"
                        onClick={() => {
                          this.search = {};
                          rest.setValue('criteria', null);
                          this.getData( this.params );
                        }}>
                  <i className="fa fa-times"/>
                </button>
              </div>
            </form>
          }
        </Form>

        <div className="box-body">
          <AsyncTable className="app-table-white"
                      onFetchData={this.getData}
                      rowsText={<Translate id="users"/>}
                      {...this.state}
                      columns={[
                        { Header: <Translate id="name"/>, accessor: 'name' },
                        { Header: <Translate id="email"/>, accessor: 'email' },
                        { Header: <Translate id="username"/>, accessor: 'username' },
                        {
                          Header: <Translate id="roles"/>, accessor: 'roles', Cell: ( props ) =>
                          <span>{props.value.join( ', ' )}</span>
                        },
                        { Header: <Translate id="group"/>, accessor: 'userGroup.name', maxWidth: 70 },
                        {
                          Header: <Translate id="active"/>, accessor: 'enabled', maxWidth: 70,
                          Cell: ( props ) =>
                            props.value ? <i className="fa fa-check"/> : <i className="fa fa-close"/>
                        },
                        {
                          Header: <Translate id="externalAuthentication"/>, accessor: 'externalAuthentication', maxWidth: 90,
                          Cell: ( props ) =>
                            props.value ? <i className="fa fa-check"/> : <i className="fa fa-close"/>
                        },
                        {
                          Header: '', accessor: 'id', maxWidth: 100,
                          Cell: props =>
                            <div>
                              <Link to={`/configurations/users/edit/${props.value}`}>
                                <button className="btn btn-outline-info btn-sm mr-2">
                                  <i className="fa fa-edit"/>
                                </button>
                              </Link>
                              
                                <button className="btn btn-outline-info btn-sm mr-2" onClick={() => this.changePasswordTo( props)}>
                                  <i className="fa fa-lock"/>
                                </button>
                              
                            </div>

                        },
                      ]}
          />
        </div>
        <ChangePassword
          open={ChangePasswordModalOpened}
          onClose={this.toggleChangePassword}
          userId={this.selectedUser}
        />
      </div>
    )
  }
}

const mapStateToProps = ( state ) => ({
  isLoading: state.settings.isLoading
});

const mapDispatchToProps = dispatch => ({
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( UsersList );



// WEBPACK FOOTER //
// ./routes/app/routes/configuration/users/dashboard/index.js